import React from 'react';
import { Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Page from '../../layout/components/PageAuth.jsx';
import LoginForm from './forms/LoginForm';
import LogoColor from '../../assets/images/logo-master-color.png';
import Footer from '../../layout/components/FooterAuth';
import RightContent from './common/ContentRightLogin';
import LoginOption from './common/LoginOption';
import { _route } from '../../utils/sg.js';

function Login() {
  return (
    <Page title="Login">
      <Grid container className="auth_view">
        <Grid item lg={6} md={12} sm={12} xs={12} className="auth_view_content customScrollbar">
          <div className="signup_holder">
            <div className="web_show">
              <a className="logo_reg" href="/">
                <img src={LogoColor} alt="Logo" className="logo_auth" />
              </a>
            </div>
            <div className="signin_link web_show">
              Don't have an account?
              <Link to={_route('register')} className="login_acc_link">
                Create Account
              </Link>
            </div>
          </div>
          <div className="mob_show">
            <div>
              <a className="logo_reg" href="/">
                <img src={LogoColor} alt="Logo" className="logo_auth" />
              </a>
            </div>
          </div>
          <div className="form_main_content">
            <div className="signup_form_holder">
              <div className="title_reg_right">Welcome back</div>
              <p className="subtitle_reg_right web_show">Please enter your details to login.</p>
              <div className="sigin_link_mob mob_show">
                Don't have an account?
                <Link to={_route('register')} className="login_acc_link">
                  Create Account
                </Link>
              </div>
              <LoginForm />

              <LoginOption />
            </div>
          </div>
          <Footer />
        </Grid>

        <RightContent />
      </Grid>
    </Page>
  );
}

export default Login;
